export const DEFAULT_PROJECT_NAME_MAX_LENGTH = 40;
export const DEFAULT_PROJECT_NAME_MIN_LENGTH = 1;
export const DEFAULT_PROJECT_DESCRIPTION_MAX_LENGTH = 50000;
